import { render } from "./SearchProductView.vue?vue&type=template&id=c08105ec&scoped=true"
import script from "./SearchProductView.vue?vue&type=script&lang=js"
export * from "./SearchProductView.vue?vue&type=script&lang=js"

import "./SearchProductView.vue?vue&type=style&index=0&id=c08105ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c08105ec"]])

export default __exports__